var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItaly2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Italy@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-70.000000, -1050.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Italy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 980.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "France"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Belgium-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bahamas-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.65,0.53 C3.13746899,0.53 0.29,3.37746899 0.29,6.89 L0.29,41.16 C0.29,44.672531 3.13746899,47.52 6.65,47.52 L23.65,47.52 C23.65,31.8533333 23.65,16.1866667 23.65,0.52 L6.65,0.53 Z",
    id: "Shape",
    fill: "#57A863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.63,0.53 C23.63,16.1966667 23.63,31.8633333 23.63,47.53 L47,47.53 C47,31.8633333 47,16.1966667 47,0.53 L23.63,0.53 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.92,0.53 L47,0.53 C47,16.1966667 47,31.8633333 47,47.53 L63.92,47.53 C67.432531,47.53 70.28,44.682531 70.28,41.17 L70.28,6.89 C70.28,3.37746899 67.432531,0.53 63.92,0.53 Z",
    id: "Shape",
    fill: "#ED5565"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly2X);
export default __webpack_public_path__ + "static/media/Italy@2x.5df629e9a81b71dbacb55d8f5aed7f25.svg";
export { ForwardRef as ReactComponent };